import {ref} from 'vue';
import * as THREE from 'three';
let  camera, renderer, scene,cube,animateid;
let drawerId = ref(0);
function initEnv(){
 scene = new THREE.Scene();

 scene.background = new THREE.Color("rgb(179, 225, 157)");
 // 创建相机
 camera = new THREE.PerspectiveCamera(75, (window.innerWidth/2)  / window.innerHeight, 0.1, 1000);
 camera.position.set(0,-3,2);
 // 创建渲染器
 renderer = new THREE.WebGLRenderer({ antialias: true });
//  renderer.setSize((window.innerWidth/2) ,( window.innerHeight - 60) );
 // 添加光源
 const light = new THREE.DirectionalLight({
  color:0xffffff, 
  intensity:1.0,
//   target:(3,3,0),

});
light.position.set(4, 4, 4);
const ambientLight = new THREE.AmbientLight(0xffffff, 2.0);
scene.add(ambientLight);
        
 // 添加立方体
  const geometry = new THREE.BoxGeometry(1,1,1)
  const texture = new THREE.TextureLoader();
     const rightTexture = texture.load( require("../assets/p005.jpg"));
     const leftTexture = texture.load( require("../assets/p007.png"));
    const topTexture = texture.load( require("../assets/p008.png"));
    const bottomTexture = texture.load( require("../assets/p004.png"));
    const frontTexture = texture.load( require('../assets/p003.png'));
    const backTexture = texture.load( require('../assets/p006.png'));
 const right_material = new THREE.MeshLambertMaterial( {
        // color: 0x00fa9a,
        map: rightTexture
    } );
    const left_material = new THREE.MeshLambertMaterial( {
        // color: 0x00fa9a,
        map: leftTexture } );
    const top_material = new THREE.MeshLambertMaterial( {
        // color: 0x00fa9a,
         map: topTexture } );
    const bottom_material = new THREE.MeshLambertMaterial( {
        //  color: 0x00fa9a,
         map: bottomTexture } );
    const front_material = new THREE.MeshLambertMaterial( {
        // color: 0x00fa9a,
         map: frontTexture,
        //  side: THREE.DoubleSide 
        } );
    // const front_material_color = new THREE.MeshLambertMaterial( {
    //     // color: 0x00fa9a,
    //      map: frontTexture,
    //     //  side: THREE.DoubleSide
    //      } );
    const back_material = new THREE.MeshLambertMaterial( {
        // color: 0x00fa9a,
        map: backTexture
     } );
 cube = new THREE.Mesh(geometry, [ right_material, left_material, top_material, bottom_material,
         front_material,back_material ] );

 cube.position.set(0,0,0);

 scene.add(cube);
cube.scale.set(1.5,1.5,1.5);

 light.lookAt(cube.position);
scene.add(light);

}

function onClick(event) {
// drawerId = ref(0);
const raycaster = new THREE.Raycaster();
const mouse = new THREE.Vector2();

mouse.x = (event.clientX / window.innerWidth ) * 2 - 1;
mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

raycaster.setFromCamera(mouse, camera);

// points 是 THREE.Points 对象
const intersects = raycaster.intersectObjects(scene.children);

if (intersects.length > 0) {
    drawerId.value += 1;
    if(drawerId.value > 3) {drawerId.value = 0};
 console.log('drawerId', drawerId.value);
// 可在此触发高亮、信息展示等逻辑
}
}

function initScene() {
     animate();
}

function animate() {
  
//  cube.rotation.x += 0.01;
 cube.rotation.y += 0.009;
 renderer.render(scene, camera);
 animateid = requestAnimationFrame(animate);

}
 export {
    initScene,initEnv, renderer,camera,onClick,drawerId,animateid,scene
}